export default __webpack_public_path__ + "static/media/9.9e7b79c6.mp3";